import React, { FC, SVGProps } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  Button,
} from "@mui/material";
import "../../../../assets/css/page/CommonModal.scss";
import { ReactComponent as CrossIcon } from "../../../../assets/Images/CrossIcon.svg";
import { buttonStyles } from "../../../../assets/MUIStyles/popupStyles";
import { ReactComponent as ConfirmationIcon } from "../../../../assets/icons/Confirmation.svg";
import { LoadingSlides } from "../Common";

interface ConfirmationPopupProps {
  message: string;
  show: boolean;
  toggle: () => void;
  handleSave: () => void;
  heading: string;
  Icon: FC<SVGProps<SVGSVGElement>>;
  headerText?: string;
  confirmText?: string;
  cancelText?: string;
  spin?: boolean;
}

const ConfirmationPopup = ({
  headerText = "Confirm",
  message,
  show,
  toggle,
  handleSave,
  heading = "",
  Icon = ConfirmationIcon,
  confirmText = "Confirm",
  cancelText = "Cancel",
  spin = false,
}: ConfirmationPopupProps) => {
  return (
    <Dialog
      open={show}
      onClose={toggle}
      scroll="body"
      classes={{ paper: "common-modal-450" }}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          maxWidth: 450,
          width: "100%",
        },
      }}
    >
      <DialogTitle
        className="new-modal-header popup-header"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          bgcolor: "#F1F4FA",
          borderBottom: "1px solid #e3e6f0",
          padding: "1.1rem 2rem !important",
        }}
      >
        <span className="font-14-600-grey">{headerText}</span>
        <IconButton onClick={toggle} className="modal-cross-icon" size="small">
          <CrossIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        className="new-modal-body"
        sx={{ padding: "1rem 2rem !important" }}
      >
        <Box className="flex-column" sx={{ justifyContent: "center" }}>
          <Box className="flex-xy-center">
            <Box className="flex-column-center" sx={{ width: "270px" }}>
              <Icon style={{ width: "150px", height: "150px" }} />
              <Typography className="font-18-600-grey text-center mt-2">
                {heading}
              </Typography>
            </Box>
          </Box>

          <Typography className="font-14-lightgrey text-center mt-1">
            {message}
          </Typography>
        </Box>

        <Box
          className="flex-between"
          sx={{
            my: 3,
            px: 1.5,
            gap: 2,
          }}
        >
          <Button sx={buttonStyles.cancel} onClick={toggle}>
            {cancelText}
          </Button>
          <Button
            className="flex-xy-center"
            sx={buttonStyles.saveButton}
            onClick={handleSave}
            disabled={spin}
          >
            {spin ? <LoadingSlides bgColor="white" /> : confirmText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationPopup;
